import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import axios from 'axios';
import dateUtil from "date-and-time";
import { getCDNUrl } from "../commons/CommonFunctions";
import ProjectDetailsCommonModal from "../UnauthPageItem/ProjectDetailsCommonModal";
import AuthModalComponent from "../LoginExtra/AuthModalComponent";
import * as _ from "lodash";

class CommonProjectViewSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ogData: {},
            loginRequired: false,
            isProjectModalOpen: false,
            projectDetail: {},
            pathname: ''
        }
    };

    componentDidMount(){
        if(this.props?.item && this.props?.item !== null && this.props?.sectionType !== "OPPORTUNITES"){
            this.getLinkPreviewUrl(this.props?.item);
        } 
    }

    getLinkPreviewUrl = (text) => {
        let data = {
            url: text
        }
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_userServiceURL}/recommend/ogscrapper`,
            data: data,
            withCredentials: true
        }).then((response) => {
            if (response?.data?.status === 200) {
                this.setState({
                    ogData: response?.data?.data
                })
            }
        }).catch((error) => {
            console.log("Error", error);
        })
    };

    isPathPresentInURL = (url, path) => {
        const urlObject = new URL(url);
        return urlObject.pathname.includes(path);
    }

    handleOpenProjectModal = (slug) => {
        let checkedUrl = slug;

        if(this.props?.sectionType !== "OPPORTUNITES"){
            let idxSlash = this.props?.item.lastIndexOf("/") + 1;
            slug = this.props?.item.substr(idxSlash, this.props?.item.length).toLowerCase();

            if(this.isPathPresentInURL(checkedUrl,'/project/feeds/')){
                this.setState({
                    isProjectModalOpen : true,
                    pathname: `/project/feeds/${slug}`
                },() => {
                    this.getUnauthProjectDetails(slug);
                })
            }else{
                window.open(checkedUrl, '_blank');
            }

        }else{
            this.setState({
                isProjectModalOpen : true,
                pathname: `/project/feeds/${slug}`
            },() => {
                this.getUnauthProjectDetails(slug);
            })
        }
    };

    getUnauthProjectDetails = (slug) => {
        axios({
          method: "get",
          url: `${process.env.REACT_APP_userServiceURL}/unauth/find-project-description-details-by-slug/${slug}`,
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        })
          .then((response) => {
            let res = response?.data;
            if (res.status === "200 OK") {
              this.setState({ projectDetail: res?.body }, () => {
                if (this.state.projectDetail && this.state.projectDetail.project) {
                  if (this.state.projectDetail.project.title) {
                    document.title =
                      this.state.projectDetail.project.title +
                      " | New opportunities and projects to explore | WeNaturalists";
                  } else if (this.state.projectDetail.project.title) {
                    document.title =
                      this.state.projectDetail.project.title +
                      " | New opportunities and projects to explore | WeNaturalists";
                  } else if (this.state.projectDetail.project.title) {
                    document.title =
                      this.state.projectDetail.project.sessionTitle +
                      " | New opportunities and projects to explore | WeNaturalists";
                  } else if (this.state.projectDetail.project.title) {
                    document.title =
                      this.state.projectDetail.project.title +
                      " | New opportunities and projects to explore | WeNaturalists";
                  }
                }
              });
              window.$("#projectDetails").modal("show");
            }
          })
          .catch((err) => {
            if (err && err.response) {
              this.setState({
                notFoundstatusCode: err.response.status,
                error: { message: err.response.data.message, err: err.response },
              });
            }
            this.setState({
              isLoaded: true,
            });
          });
      };

    openModalClose = () => {
        this.setState({
            slug: "",
            isProjectModalOpen: false,
            pathname: ''
        });
        window.$("#projectDetails").modal("hide");
    };
    
    handleApply = () => {
        this.setState({
            loginRequired: true,
          },() => {
            window.$("#loginModal").modal("show");
          }
        );
    };

    handleLoginClose = () => {
        this.setState({ loginRequired: false });
        window.$("#loginModal").modal("hide");
    };

    render() {
        const{ogData,projectDetail,isProjectModalOpen} = this.state;
        const{sectionType,item} = this.props;

        return (
                <>
                    {sectionType !== "OPPORTUNITES" ?
                        <div className={`col-md-6${sectionType !== "TRENDING_CONTENT" ? "" : " col-lg-3"}`} onClick={() => {this.handleOpenProjectModal(item)}}>
                            {this.isPathPresentInURL(item,'/project/feeds/') ?
                                <div className="lndprojeventlist">
                                    <div className="lndprojeventlistinn">
                                        <figure className="lndeventimg">
                                            <LazyLoadImage effect="blur"
                                                src={ogData.image ? getCDNUrl(ogData?.image) : "https://cdn.dscovr.com/images/project-default.webp"}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "https://cdn.dscovr.com/images/project-default.png"
                                                }}
                                                alt=""
                                            />
                                        </figure>
                                        <div className="lndprojeventdesc">
                                            {ogData && ogData.title && <h4>{ogData.title}</h4>}
                                            <div className="d-flex">
                                                {ogData && ogData.description && <div className="lndprojeventdesctxt">
                                                    <p>{ogData.description}</p>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                :
                                <div className="lndprojeventlist others">
                                    <div className="lndprojeventlistinn">
                                        <figure className="lndeventimg">
                                            <LazyLoadImage effect="blur"
                                                src={ogData.image ? getCDNUrl(ogData?.image) : "https://cdn.dscovr.com/images/project-default.webp"}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "https://cdn.dscovr.com/images/project-default.png"
                                                }}
                                                alt=""
                                            />
                                        </figure>
                                        <div className="lndprojeventdesc">
                                            {ogData && ogData.title && <h4>{ogData.title}</h4>}                                            
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* {isProjectModalOpen &&
                                <ProjectDetailsCommonModal projectDetail={projectDetail} openModalClose={this.openModalClose} handleApply={this.handleApply} pageType={"LANDING"}/>
                            } */}
                        </div>
                        :
                        <div className='col-md-4 oppertunCol' onClick={() => {this.handleOpenProjectModal(item?.slug)}} >
                            <div className="lndprojeventlist">
                                <div className="lndprojeventlistinn">
                                    <figure className="lndeventimg">
                                        <LazyLoadImage effect="blur"
                                            src={
                                                item?.coverImage ? getCDNUrl( item?.coverImage) : "http://cdn.beegram.net/posts/300x300-6475995bb5b2e13d705517e3-1685428573284.jpg"
                                            }
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = "https://cdn.dscovr.com/images/project-default.png"
                                            }}
                                            alt="" />
                                    </figure>
                                    <div className="lndprojeventdesc">
                                        <div className="d-flex">
                                            <div className="lnddate">
                                                {dateUtil.format(new Date(item && item?.project?.beginningTime),"DD")}
                                                <span>
                                                    {!_.isUndefined(item.project.beginningTime) && !_.isNull(item.project.beginningTime) && dateUtil.format(new Date(item && item.project.beginningTime),"MMM").toUpperCase()}                                                
                                                 </span>
                                                <span>
                                                    {!_.isUndefined(item.project.beginningTime) && !_.isNull(item.project.beginningTime) && dateUtil.format(new Date(item && item.project.beginningTime),"YYYY").toUpperCase()}
                                                </span>
                                            </div>
                                            <div className="lndprojeventdesctxt">
                                            {item?.title && <h4>{item.title}</h4>}
                                               {item?.country && <span class="lndaddress">{item.country}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* {isProjectModalOpen &&
                                <ProjectDetailsCommonModal projectDetail={projectDetail} openModalClose={this.openModalClose} handleApply={this.handleApply} pageType={"LANDING"}/>
                            } */}
                        </div>
                    }

                    {isProjectModalOpen &&
                        <ProjectDetailsCommonModal projectDetail={projectDetail} openModalClose={this.openModalClose} handleApply={this.handleApply} pageType={"LANDING"}/>
                    }

                    {this.state.loginRequired && 
                        <AuthModalComponent handleLoginClose={this.handleLoginClose} pathname={this.state.pathname} history={this.props.history} />
                    }
                </>
            );
    }
}

export default CommonProjectViewSection;